import React, { useRef } from 'react';
import { motion, useInView } from 'framer-motion';
import { SparklesIcon } from 'lucide-react';
export function UniqueMechanism() {
  const ref = useRef(null);
  const isInView = useInView(ref, {
    once: true,
    margin: '-100px'
  });
  return <section ref={ref} className="px-6 py-20" style={{
    backgroundColor: 'var(--color-background-alt)'
  }} data-id="element-99">
      <div className="max-w-3xl mx-auto" data-id="element-100">
        <motion.div initial={{
        opacity: 0,
        y: 30
      }} animate={isInView ? {
        opacity: 1,
        y: 0
      } : {}} transition={{
        duration: 0.5,
        ease: 'easeOut'
      }} className="text-center mb-8" data-id="element-101">
          <span className="inline-flex items-center gap-2 px-4 py-2 rounded-full text-sm font-medium mb-6" style={{
          backgroundColor: 'var(--color-accent)',
          color: 'white'
        }} data-id="element-102">
            <SparklesIcon className="w-4 h-4" data-id="element-103" />
            The Unique Mechanism
          </span>

          <h2 className="text-3xl md:text-4xl font-bold" style={{
          fontFamily: 'var(--font-heading)',
          color: 'var(--color-text)'
        }} data-id="element-104">
            The Low-Dopamine Reset (LDR)
          </h2>
        </motion.div>

        <motion.div initial={{
        opacity: 0,
        y: 30
      }} animate={isInView ? {
        opacity: 1,
        y: 0
      } : {}} transition={{
        duration: 0.5,
        ease: 'easeOut',
        delay: 0.1
      }} className="space-y-6" data-id="element-105">
          <p className="text-lg text-center" style={{
          color: 'var(--color-text)'
        }} data-id="element-106">
            This isn't a permanent ban on technology. It is a tactical{' '}
            <strong data-id="element-107">48-hour biological "reboot."</strong>
          </p>

          <div className="p-8 rounded-lg text-center" style={{
          backgroundColor: 'var(--color-background)',
          border: '2px solid var(--color-accent)'
        }} data-id="element-108">
            <p className="text-xl leading-relaxed" style={{
            color: 'var(--color-text)'
          }} data-id="element-109">
              By following a specific sequence of "Low-Dopamine" sensory
              replacements, we lower your child's stimulation baseline. Within
              48 hours, their brain resets so they can find{' '}
              <strong data-id="element-110">genuine joy</strong> in books, toys, and independent play
              again.
            </p>
          </div>
        </motion.div>
      </div>
    </section>;
}